import { lt, gt, isNull } from 'lodash';
import { COMMON_ERRORS } from '_constants/errors';
import { hasFalsyValue } from '..';
/**
 * Validate input text object and returns error string
 * @param  {string} {value
 * @param  {string} name
 * @param  {number} min=null
 * @param  {number} max=null
 * @param  {boolean} required=false}
 *
 * @returns {string} error | ''
 */
export default ({ value, name, min = null, max = null, required = false }) => {
  let error =
    (hasFalsyValue(value) && COMMON_ERRORS.isRequired(name)) ||
    (!isNull(min) && lt(value.length, min) && COMMON_ERRORS.lessThan(name, min)) ||
    (!isNull(max) && gt(value.length, max) && COMMON_ERRORS.moreThan(name, max));
  error = !required && hasFalsyValue(value) ? null : error;
  if (name === 'atcc') {
    if (!value) return false;

    const currentYear = new Date().getFullYear();

    const years = value.split(',').map((y) => y.trim());

    const errorText = years
      .map((yearStr) => {
        if (!/^\d{4}$/.test(yearStr)) {
          return `Each value must be a 4-digit year (e.g. ${currentYear})`;
        }
        const year = parseInt(yearStr, 10);
        if (year <= 2000) {
          return 'Each year must be greater than 2000';
        }
        if (year > currentYear) {
          return `Year cannot be later than ${currentYear}`;
        }

        return null;
      })
      .find(Boolean);

    return errorText || false;
  }
  if (name === 'synar_year') {
    // Comma-separated list of Synar years (P20M-1388/P20M-1338). Unlike atcc,
    // a future year is legal: the sample for the NEXT fiscal year is uploaded
    // before that FY starts. Bounds mirror the backend (2000..2100).
    if (!value) return false;

    const errorText = value
      .split(',')
      .map((y) => y.trim())
      .map((yearStr) => {
        if (!/^\d{4}$/.test(yearStr)) {
          return 'Each value must be a 4-digit year (e.g. 2027), comma-separated';
        }
        const year = parseInt(yearStr, 10);
        if (year < 2000 || year > 2100) {
          return 'Each year must be between 2000 and 2100';
        }
        return null;
      })
      .find(Boolean);

    return errorText || false;
  }
  return error;
};
